import ModalLiveAccessEmailCapture from './ModalLiveAccessEmailCapture'

export default ModalLiveAccessEmailCapture
// eslint-disable-next-line import/export
export * from './ModalLiveAccessEmailCapture'
